import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import s from './NewsList.module.css';
import testIcon from '../../assets/icons/newsPhoto2.jpg';
import { newsApi } from '../../api/news';
import { News } from '../../types/api.types';

export const NewsList: React.FC = () => {
    const navigate = useNavigate();
    const [news, setNews] = useState<News[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadNews();
    }, []);

    const loadNews = async () => {
        try {
            setLoading(true);
            const data = await newsApi.getAll();
            console.log('📦 Новости с бэка:', data);
            setNews(data);
        } catch (error) {
            console.error('Ошибка загрузки новостей:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleCardClick = (id: number) => {
        navigate(`/news/${id}`);
    };

    const stripHtml = (html: string) => {
        if (!html) return '';
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || '';
    };

    const extractFirstImageFromHtml = (html: string): string | null => {
        if (!html) return null;
        const imgMatch = html.match(/<img[^>]+src="([^">]+)"/);
        return imgMatch ? imgMatch[1] : null;
    };

    const extractFirstParagraphFromHtml = (html: string): string => {
        if (!html) return '';
        const pMatch = html.match(/<p[^>]*>([^<]*)<\/p>/);
        return pMatch ? pMatch[1] : '';
    };

    if (loading) {
        return <div className={s.loading}>Загрузка...</div>;
    }

    return (
        <div className={s.newsPage}>
            <h1 className={s.pageTitle}>Новости</h1>
            <div className={s.newsList}>
                {news.map(item => {
                    const htmlContent = item.content?.html || '';

                    const firstImageSrc = extractFirstImageFromHtml(htmlContent);

                    const firstParagraph = extractFirstParagraphFromHtml(htmlContent);

                    const displayText = item.displayDescription || firstParagraph || item.title || '';

                    return (
                        <div
                            key={item.id}
                            className={s.newsCard}
                            onClick={() => handleCardClick(item.id)}
                        >
                            <div className={s.newsImageWrapper}>
                                <img
                                    src={firstImageSrc || testIcon}
                                    alt={item.title}
                                    className={s.newsImage}
                                />
                            </div>
                            <div className={s.newsContent}>
                                <h3 className={s.newsTitle}>{item.title}</h3>
                                <p className={s.newsDescription}>
                                    {stripHtml(displayText)}
                                </p>
                                <div className={s.newsDate}>
                                    {new Date(item.dateCreating).toLocaleDateString('ru-RU')}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};